import React, { useEffect, useMemo, useState } from "react";
import Footer from "../Header/Footer";
import Header from "../Header/Header";
import Config from "../Header/Config";
import { useNavigate } from "react-router-dom";
import {
  FaEdit,
  FaEye,
  FaRegEye,
  FaShoppingCart,
  FaTrash,
  FaTrashAlt,
  FaFileExcel,
  FaFilePdf,
} from "react-icons/fa";
import { exportFilteredToExcel } from "../../utils/excelExport";
import { exportFilteredToPDF } from "../../utils/pdfExport";
const ITEMS_PER_PAGE = 500; // Number of items to display per page
export default function User_ModelList() {
  const [tableData, setTableData] = useState([]);
  const [brand, setBrand] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const apiUrl = Config.apiUrl;
  //................................................................[ fetch all data ]...........................................................
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [purchaseDetailsResponse, purchaseItemsResponse] =
          await Promise.all([
            fetch(`${apiUrl}/get_all_purchaseDetails`),
            fetch(`${apiUrl}/get_all_purchaseItems`),
          ]);

        if (!purchaseDetailsResponse.ok || !purchaseItemsResponse.ok) {
          throw new Error("Failed to fetch data");
        }

        const purchaseDetailsData = await purchaseDetailsResponse.json();
        const purchaseItemsData = await purchaseItemsResponse.json();

        setTableData(purchaseDetailsData.data.reverse());
        setBrand(purchaseItemsData.data.reverse());
        setIsLoading(false);

        console.log("Purchase Details Data:", purchaseDetailsData);
        console.log("Purchase Items Data:", purchaseItemsData);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error state or show an error message to the user
        setIsLoading(false);
      }
    };

    fetchData();
  }, [apiUrl]);

  //.................................................................. [ combine 2 api's data ].....................................
  const combinedData = useMemo(() => {
    if (brand.length === 0 || tableData.length === 0) {
      return [];
    }

    return brand.map((row) => {
      const brandItem = tableData.find(
        (item) => item.invoice_no === row.invoice_no
      );

      if (brandItem) {
        return {
          ...row,
          date: brandItem.date,
          supplier_name: brandItem.supplier_name,
        };
      }

      return row;
    });
  }, [brand, tableData]);

  //..............................................................

  const navigate = useNavigate();

  const handleView = async (id) => {
    const invoice = id;
    navigate(`/purchase_invoice?invoice_no=${invoice}`);
  };

  //................................................................

  const handleUpdate = async (id, event) => {
    const invoice = id;
    navigate(`/purchase_update?invoice_no=${invoice}`);
  };

  //..................................................................

  // Delete Record from database
  const handleDelete = (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this record?"
    );

    if (confirmDelete) {
      fetch(`${apiUrl}/delete_purchaseDetails/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        // Set the new status value to 1 (deleted)
      })
        .then((response) => response.json())
        .then(() => {
          alert(id);
          // Reload the page to reflect the updated data (with the deleted row removed)
          window.location.reload();
        })
        .catch((error) => {
          console.error("Error updating status:", error);
        });
    }
  };

  //............................[ search box]..............................................
  const [searchQuery, setSearchQuery] = useState(""); // State variable for the search query

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const filteredTableData = combinedData.filter(
    (row) =>
      (row.model_name &&
        row.model_name.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (row.purchase_price &&
        row.purchase_price.toString().includes(searchQuery.toString())) ||
      (row.invoice_no &&
        row.invoice_no.toString().includes(searchQuery.toString())) ||
      (row.supplier_name &&
        row.supplier_name.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (row.imei &&
        row.imei.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (row.date && row.date.toString().includes(searchQuery.toString()))
  );

  //..................................[ Pagination ].........................................

  const [currentPage, setCurrentPage] = useState(1);

  // Calculate the total number of pages based on the data and items per page
  const totalPages = Math.ceil(filteredTableData.length / ITEMS_PER_PAGE);

  // Calculate the index range for the items to be displayed on the current page
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = Math.min(
    startIndex + ITEMS_PER_PAGE,
    filteredTableData.length
  );

  // Function to handle pagination button clicks
  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  // Excel Export Handler
  const handleExportToExcel = () => {
    const columns = [
      { key: 'model_name', label: 'Model Name' },
      { key: 'color', label: 'Color' },
      { key: 'imei', label: 'IMEI' },
    ];
    exportFilteredToExcel(filteredTableData, columns, 'UserModelList');
  };

  // PDF Export Handler
  const handleExportToPDF = () => {
    const columns = [
      { key: 'model_name', label: 'Model Name' },
      { key: 'color', label: 'Color' },
      { key: 'imei', label: 'IMEI' },
    ];
    exportFilteredToPDF(filteredTableData, columns, 'UserModelList');
  };

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <h4 className="fw-bold py-3 mb-4">Model List</h4>

                <hr className="my-5" />
                {/* Search Box and Export Button */}
                <div style={{ display: "flex", justifyContent: "end", gap: "10px", alignItems: "center" }}>
                  <div className="mb-3 col-md-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={handleSearch}
                    />
                  </div>
                  {/* <div className="mb-3">
                    <button
                      className="btn btn-success"
                      onClick={handleExportToExcel}
                      disabled={!filteredTableData || filteredTableData.length === 0}
                      title="Export to Excel"
                      style={{ display: "flex", alignItems: "center", gap: "5px" }}
                    >
                      <FaFileExcel />
                      Export Excel
                    </button>
                  </div> */}
                  <div className="mb-3">
                    <button
                      className="btn btn-danger"
                      onClick={handleExportToPDF}
                      disabled={!filteredTableData || filteredTableData.length === 0}
                      title="Export to PDF"
                      style={{ display: "flex", alignItems: "center", gap: "5px" }}
                    >
                      <FaFilePdf />
                      Export PDF
                    </button>
                  </div>
                </div>

                <div className="card">
                  <h5 className="card-header">Model List</h5>
                  <div
                    className="table-container"
                    style={{ overflowY: "auto", maxHeight: "600px" }}
                  >
                    {isLoading ? (
                      <div className="d-flex justify-content-center mb-5">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="sr-only "></span>
                        </div>
                      </div>
                    ) : (
                      <table className="table">
                        <thead
                          style={{
                            position: "sticky",
                            top: 0,
                            zIndex: 1,
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          <tr className="text-nowrap" style={{ backgroundColor: "yellow", color: "Black" }}>
                            <th style={{ width: "10%" }}>Sr</th>
                            <th style={{ width: "30%" }}>Model Name</th>
                            <th style={{ width: "30%" }}>Color</th>
                            <th style={{ width: "30%" }}>IMEI</th>

                          </tr>
                        </thead>

                        <tbody>
                          {Array.isArray(filteredTableData) &&
                            filteredTableData.length > 0 ? (
                            filteredTableData
                              .slice(startIndex, endIndex)
                              .map((row, index) => {
                                const originalIndex = combinedData.findIndex(item => (item.imei === row.imei));
                                return (
                                <tr key={index} >
                                  <td>{originalIndex !== -1 ? originalIndex + 1 : startIndex + index + 1}</td>
                                  <td>{row.model_name}</td>
                                  <td>{row.color}</td>
                                  <td style={{ backgroundColor: "#FFCCCB", color: "black" }}>
                                    <b>{row.imei}</b>
                                  </td>

                                </tr>
                                );
                              })
                          ) : (
                            <tr>
                              <td colSpan="6">No data available</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
                {/* Pagination */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "10px 10px",
                  }}
                >
                  <nav aria-label="Page navigation">
                    <ul className="pagination">
                      {/* Previous arrow button */}
                      <li
                        className={`page-item ${currentPage === 1 ? "disabled" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          {"<"}
                        </button>
                      </li>

                      {/* Page numbers */}
                      {Array.from(
                        { length: totalPages },
                        (_, index) => index + 1
                      ).map(
                        (pageNumber) =>
                          // Render the page number button only if it's within the range of visible pages
                          pageNumber >= currentPage - 2 &&
                          pageNumber <= currentPage + 2 && (
                            <li
                              key={pageNumber}
                              className={`page-item ${pageNumber === currentPage ? "active" : ""
                                }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => handlePageChange(pageNumber)}
                              >
                                {pageNumber}
                              </button>
                            </li>
                          )
                      )}

                      {/* Next arrow button */}
                      <li
                        className={`page-item ${currentPage === totalPages ? "disabled" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          {">"}
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>

              <Footer />

              <div className="content-backdrop fade" />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle" />
      </div>
    </>
  );
}
